import { createTheme } from "@mui/material/styles";
import { headlineFont, bodyFont } from "./fonts";
import { COLORS } from "./colors";

// Define common typography and components configurations
const commonTypography = {
  fontFamily: bodyFont, // Default font for the body text
  allVariants: {
    fontFamily: bodyFont, // Ensure all variants inherit body font by default
  },
  h1: {
    fontFamily: headlineFont,
    fontSize: "64px",
    fontWeight: 600,
    lineHeight: 1.2,
  },
  h2: {
    fontFamily: headlineFont,
    fontSize: "48px",
    fontWeight: 600,
    lineHeight: 1.2,
  },
  h3: {
    fontFamily: headlineFont,
    fontSize: "36px",
    fontWeight: 500,
    lineHeight: 1.3,
  },
  h4: {
    fontFamily: headlineFont,
    fontSize: "27px",
    fontWeight: 500,
    lineHeight: 1.4,
  },
  h5: {
    fontFamily: headlineFont,
    fontSize: "20px",
    fontWeight: 500,
    lineHeight: 1.4,
  },
  h6: {
    fontFamily: headlineFont,
    fontSize: "16px",
    fontWeight: 400,
    lineHeight: 1.5,
  },
  body1: {
    fontFamily: bodyFont,
    fontSize: "16px",
    lineHeight: 1.6,
  },
  body2: {
    fontFamily: bodyFont,
    fontSize: "14px",
    lineHeight: 1.5,
  },
};

const commonComponents = {
  MuiButton: {
    styleOverrides: {
      root: {
        // Add empty objects for variants you want to override
        contained: {},
        outlined: {},
        text: {},
      },
    },
  },
  MuiPaper: {
    styleOverrides: {
      root: {
        padding: "16px",
        backgroundColor: "#ffffff",
        border: "1px solid rgba(0, 0, 0, 0.1)",
      },
    },
  },
  MuiTextField: {
    styleOverrides: {
      root: {
        "& .MuiInputBase-root": {
          "& input": {
            color: "inherit",
          },
        },
      },
    },
  },
  MuiAppBar: {
    styleOverrides: {
      root: {
        backdropFilter: "blur(10px)",
        backgroundColor: "rgba(255, 255, 255, 0.9)",
        borderBottom: "1px solid rgba(0, 0, 0, 0.1)",
        color: "#1a1a1a",
      },
    },
  },
  MuiLink: {
    styleOverrides: {
      root: {
        color: "primary.main",
        textDecoration: "none",
        "&:hover": {
          textDecoration: "underline",
        },
        "&:visited": {
          color: "primary.light",
        },
        "&:active": {
          color: "primary.light",
        },
      },
    },
  },
};

// Create a single theme configuration
export const theme = createTheme({
  shape: {
    borderRadius: 0,
  },
  typography: commonTypography,
  palette: {
    mode: "light",
    primary: {
      main: COLORS.PRIMARY,
      light: COLORS.PRIMARY_LIGHT,
      contrastText: "#ffffff",
    },
    secondary: {
      main: COLORS.SECONDARY,
      contrastText: "#ffffff",
    },
    background: {
      default: "#ffffff",
      paper: "#f8f9fa",
    },
    text: {
      primary: "#1a1a1a",
      secondary: "#666666",
    },
    divider: "rgba(0, 0, 0, 0.1)",
  },
  components: commonComponents,
});
